import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryOptions } from '@tanstack/react-query'
import { getKambiPendingBetHistory, getKambiPendingBetsCashOutStatus } from '../api'

const enum LocalConstants {
  PollingTimeMs = 1_000 * 60 * 15, // 15mins
}

export const kambiPendingBetHistoryQuery = queryOptions({
  queryKey: queryKeys.kambiPendingPlayerHistory,
  queryFn: getKambiPendingBetHistory,
  refetchOnWindowFocus: true,
  refetchOnMount: true,
  staleTime: LocalConstants.PollingTimeMs,
  refetchInterval: LocalConstants.PollingTimeMs,
})

export const kambiPendingBetsCashOutStatusQuery = queryOptions({
  queryKey: [queryKeys.kambiPendingPlayerHistory, 'cashout-status'],
  queryFn: getKambiPendingBetsCashOutStatus,
  refetchOnWindowFocus: true,
  refetchOnMount: true,
  staleTime: LocalConstants.PollingTimeMs,
  refetchInterval: LocalConstants.PollingTimeMs,
})
